module.exports = __webpack_public_path__ + "assets/img/mecha-ce40c53f.png";